import { Component, ComponentInterface, JSX, Prop, h } from '@stencil/core';
import { store } from 'app/shared/store/store';
import { PromotionPage } from 'app/shared/models/product-response.model';
import { bannerService } from 'app/shared/services/banner/banner.service';

@Component({
  tag: 'app-promo-banner'
})
export class PromoBanner implements ComponentInterface {
  @Prop() public readonly dataSpa: string = null;
  private promotionPage: PromotionPage = null;
  private content: string = null;
  private footer: string = null;
  private imagePath: string = null;

  private getBannerContent(): void {
    this.promotionPage = store.get('promotionPage');
    // Currently, BFF is not serving promotion page data, promotion page data is setup per plan in stripCoupon field
    if (this.promotionPage?.isPromoValid) {
      const promoBannerDetails = this.promotionPage?.promoBanner;
      this.content = promoBannerDetails?.content;
      this.footer = promoBannerDetails?.footer;
      this.imagePath = promoBannerDetails?.imagePath;
    }
  }

  render(): JSX.Element {
    this.getBannerContent();
    if (!this.promotionPage?.isPromoValid) {
      return null;
    }
    return (
      <agl-ds-hero-banner banner-title={bannerService.getBannerTitle(this.dataSpa)} image-path={this.imagePath} image-position="right">
        <span slot="description">
          <agl-ds-spacer orientation="vertical" size="space02" />
          <agl-ds-h1 styled-as="title1" font="fontfamily02" appearance="inverse">
            {this.content}
          </agl-ds-h1>
          <agl-ds-p styled-as="lg" font="fontfamily02" appearance="inverse">
            {this.footer}
          </agl-ds-p>
        </span>
      </agl-ds-hero-banner>
    );
  }
}
